/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  pageHeading: {
    id: "b2b.rezervace.vytvoreni.page-heading",
    defaultMessage: "New Reservation"
  },
  casovyPlanPageHeading: {
    id: "b2b.rezervace.casovy-plan.page-heading",
    defaultMessage: "Timetable"
  }
});

export default () => useMessages(MESSAGES);
